var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFosteraCultureofContinuousLearning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 10.2273C7.26136 10.2273 2.96591 11.0455 0 13.2955V43.2818C0 43.7932 0.511364 44.3045 1.02273 44.3045C1.22727 44.3045 1.32955 44.1614 1.53409 44.1614C4.29545 42.8318 8.28409 41.9318 11.25 41.9318C15.2386 41.9318 19.5341 42.75 22.5 45C25.2614 43.2614 30.2727 41.9318 33.75 41.9318C37.125 41.9318 40.6023 42.5659 43.4659 44.1C43.6705 44.2023 43.7727 44.1614 43.9773 44.1614C44.4886 44.1614 45 43.65 45 43.1386V13.2955C43.7727 12.375 42.4432 11.7614 40.9091 11.25V38.8636C38.6591 38.1477 36.2045 37.8409 33.75 37.8409C30.2727 37.8409 25.2614 39.1705 22.5 40.9091V13.2955C19.5341 11.0455 15.2386 10.2273 11.25 10.2273Z",
    fill: "#171C8F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6136 9.20455L37.8409 0V26L27.6136 35V9.20455Z",
    fill: "#256BE4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFosteraCultureofContinuousLearning);
export default __webpack_public_path__ + "static/media/FosteraCultureofContinuousLearning.7809d4f9ad7d235ddde0053075abe76e.svg";
export { ForwardRef as ReactComponent };